// import {exampleApi} from '@/api';
export default {
  namespaced: true,
  state: {
    trends: []
  },
  mutations: {
    SET_TRENDS(state: ExampleState, trends: string[]): void {
      state.trends = trends;
    }
  }
}

interface ExampleState {
  trends: string[];
}
